<style>

h3{
  text-align: center;
}

.space{
  margin: 20px;
}

.photos{
  display: grid;
  grid-template-columns: 50% 50%;
  grid-auto-rows: 165px;
  align-items: center;
  justify-items: center;
}
.r1c1{
  grid-column: 1;
  grid-row: 1;
}
.r1c2{
  grid-column: 2;
  grid-row: 1;
}
.r2c1{
  grid-column: 1;
  grid-row: 2;
}
.r2c2{
  grid-column: 2;
  grid-row: 2;
}
.r3c1{
  grid-column: 1;
  grid-row: 3;
}
.r3c2{
  grid-column: 2;
  grid-row: 3;
}

.photo{
  width: 150px;
  height: 150px;
  border: 2px #777 solid;
  /* border-radius: 150px; */
  border-radius: 10px;
  margin: auto;
}

.plus{
  width: 150px;
  height: 150px;
  padding: 47px 0 0 3px;
  font-size: 41px;
  color: white;
  text-align: center;
}

.profile-pic{
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
}


/* add/edit images */
.image{
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 500px;
}

.out{
  border: 1px gray solid;
  margin-bottom: 10px;
  display: none;
}
.button-container{
  position: fixed;
  z-index: 51;
  left: 0;
  right: 0;
  bottom: 51px;
}
.buttons{
  margin: 20px;
}

.center{
  text-align: center;
  color: white;
}
.icon-supervised_user_circle{
  font-size: 150px;
}
.icon-camera_alt{
  font-size: 50px;
}

</style>

<Auth bind:this="{auth}"></Auth>
<Profile bind:this="{profile}" bind:me="{me}"></Profile>

{#if show}


{#if photosAdd}
  
  {#if photo}
    
  <div class="image">
    <Cropper image="{photo}" bind:crop bind:zoom aspect="{1}" on:cropcomplete="{doCrop}"></Cropper>
  </div>

  <!-- hidden element -->
  <div class="out">
    <img id="image" src="{out}" alt="">
  </div>

  <!-- hidden element -->
  <div class="out">
    <canvas id="canvas" width="1000px" height="1000px"></canvas>
  </div>
  
  <div class="button-container">
    <div class="buttons">
      <button on:click="{addPhoto}">Upload New Photo</button>
    </div>
    <div class="buttons">
      <button on:click="{clearPhoto}">Clear Photo</button>
    </div>
  </div>

  {:else}

  <div class="title-signup" on:click="{addPhoto}">Add a photo</div>

  <div class="center" on:click="{addPhoto}">
    <i class="icon-supervised_user_circle"></i>
  </div>

  <div class="center" on:click="{addPhoto}">
    <i class="icon-camera_alt"></i>
  </div>

  <div class="buttons">
    <button on:click="{addPhoto}">+ Add Photo</button>
  </div>
  
  {/if}
  
  <input style="display:none" type="file" accept=".jpg, .jpeg, .png" on:change="{ (e) => onFileSelected(e) }" bind:this="{fileInput}" >
  
{:else}
  
<h3>Add photos</h3>
  
<div class="photos">
  <div class="r1c1">
    <div class="photo">
      {#if photos[0].p}
        <!-- load local image -->
        <img src="{photos[0].p}" class="profile-pic" on:click="{ () => photoClicked(0) }">
      {:else}
        <!-- no image yet... -->
        <div class="plus" on:click="{ () => photoClicked(0) }">+</div>
      {/if}
    </div>
  </div>
  <div class="r1c2">
    <div class="photo">
      {#if photos[1].p}
        <img src="{photos[1].p}" class="profile-pic" on:click="{ () => photoClicked(1) }">
      {:else}
        <div class="plus" on:click="{ () => photoClicked(1) }">+</div>
      {/if}
    </div>
  </div>
  
  <div class="r2c1">
    <div class="photo">
      {#if photos[2].p}
        <img src="{photos[2].p}" class="profile-pic" on:click="{ () => photoClicked(2) }">
      {:else}
        <div class="plus" on:click="{ () => photoClicked(2) }">+</div>
      {/if}
    </div>
  </div>
  <div class="r2c2">
    <div class="photo">
      {#if photos[3].p}
        <img src="{photos[3].p}" class="profile-pic" on:click="{ () => photoClicked(3) }">
      {:else}
        <div class="plus" on:click="{ () => photoClicked(3) }">+</div>
      {/if}
    </div>
  </div>
  
  <div class="r3c1">
    <div class="photo">
      {#if photos[4].p}
        <img src="{photos[4].p}" class="profile-pic" on:click="{ () => photoClicked(4) }">
      {:else}
        <div class="plus" on:click="{ () => photoClicked(4) }">+</div>
      {/if}
    </div>
  </div>
  <div class="r3c2">
    <div class="photo">
      {#if photos[5].p}
        <img src="{photos[5].p}" class="profile-pic" on:click="{ () => photoClicked(5) }">
      {:else}
        <div class="plus" on:click="{ () => photoClicked(5) }">+</div>
      {/if}
    </div>
  </div>
</div>

{/if}

{/if}


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Auth from "../../interfaces/Auth.svelte";
let auth;

import Profile from "../../interfaces/Profile.svelte";
let profile;

import Cropper from "svelte-easy-crop";

import Generate from "../../helpers/Generate.js";
import Photos from "../../helpers/Photos.js";

export let show = false;
export let me = null;
export let photosAdd = false;

/* 

this is just used with saveProfilePhotos on the back end.  the photoIds array is still the same everywhere else because we want to preserve the order that they were loaded.

{c: "command", i: "id", p: "photo data"}

"c" can be "nop", "new", "delete", "change"
"i" is new id
"p" is photo data
"t" is a thumbnail of photo data

if nop, that was an already saved pic that is being reloaded into the array.
if new, that is a new photo that needs to be saved
if delete, then delete that photo id
if change, then delete

because "doCrop" wants to be run, even after deleting a photo, it generates a new ID for the deleted photo, which is pretty stupid.  when deleting a photo, we need to copy "o" back to "i"

*/

let photos = [ 
  {c: "nop", i: "", p: "", t: "", m: ""},
  {c: "nop", i: "", p: "", t: "", m: ""},
  {c: "nop", i: "", p: "", t: "", m: ""},
  {c: "nop", i: "", p: "", t: "", m: ""},
  {c: "nop", i: "", p: "", t: "", m: ""},
  {c: "nop", i: "", p: "", t: "", m: ""},
];

// add ids to delete from server
let toDelete = [];

// let photos = [ "", "", "", "", "", "", ];
// let photoIds = [ "", "", "", "", "", "", ];

let uid = "";
let curPhotoId = null;

let photo = "";
let crop = { x: 0, y: 0 };
let zoom = 1;
let out = "";
let image = new Image();
let canvas = null;
let ctx = null;
let fileInput = "";

let tempPhoto = "";
let tempPhotoMedium = "";
let tempPhotoSmall = "";


import { onMount } from "svelte";
onMount(async () => {
});


$:{
  if (me) set();
}


function set() {
  
  if (show == false) return;
  
  uid = me.uid;
  let photoIds = me.photoIds;
  
  for (let i in photoIds) {
    
    if (photoIds[i] != "") {
      
      let img = new Image;
      img.crossOrigin = 'Anonymous';
      
      img.onload = () => {
        // console.log("img.src:", img.src);
        let tcanvas = document.createElement('canvas');
        let tctx = tcanvas.getContext('2d');
        tcanvas.width = img.naturalWidth;
        tcanvas.height = img.naturalHeight;
        tctx.drawImage(img, 0, 0);
        photos[i].p = tcanvas.toDataURL("image/jpeg");
        photos[i].i = photoIds[i];
      }
      
      img.src = `https://routes.hot0.workers.dev/fi/${localStorage.getItem('cookie')}/${localStorage.getItem('csrf')}/${uid}/${photoIds[i]}`;
      
    }
  }
  
  // console.log("set photos:", photos);
}


function photoClicked(index) {
  // console.log("photoClicked");
  photosAdd = true;
  curPhotoId = index;
  photo = photos[curPhotoId].p;
  image.src = photo;
}


function addPhoto() {
  fileInput.click();
}


function onFileSelected(e) {
  if (e.target.files.length > 0) {
    let timage = e.target.files[0];
    let treader = new FileReader();
    treader.readAsDataURL(timage);
    treader.onload = async (e) => {
      photo = e.target.result;
      image.src = photo;
    };
  }
}


async function doCrop(e) {
  
  // console.log("doCrop");
  
  canvas = document.getElementById('canvas');
  ctx = canvas.getContext('2d');
  
  let x = e.detail.pixels.x;
  let y = e.detail.pixels.y;
  let w = e.detail.pixels.width;
  let h = e.detail.pixels.height;
  
  ctx.drawImage(image,
        x, y,   // Start at x,y pixels from the left and the top of the image (crop),
        w, h,   // "Get" a w,h area from the source image (crop),
        0, 0,     // Place the result at 0, 0 in the canvas,
        1000, 1000); // With as w,h: 100, 100 (scale)  
  
  let tPhoto = canvas.toDataURL();
  tempPhoto = await Photos.resize(tPhoto, 800, 800, 0.7);
  tempPhotoMedium = await Photos.resize(tPhoto, 200, 200, 0.8);
  tempPhotoSmall = await Photos.resize(tPhoto, 100, 100, 0.8);
}


async function clearPhoto() {
  photo = "";
  
  if (photos[curPhotoId].i != "") {
    toDelete.push(photos[curPhotoId].i);
    toDelete.push(photos[curPhotoId].i + "_m");
    toDelete.push(photos[curPhotoId].i + "_t");
  }
  photos[curPhotoId].c = "nop";
  photos[curPhotoId].i = "";
  photos[curPhotoId].p = "";
  photos[curPhotoId].m = "";
  photos[curPhotoId].t = "";
  tempPhoto = "";
  tempPhotoMedium = "";
  tempPhotoSmall = "";
  photo = "";
  
  // console.log("clearPhoto");
  // console.log("toDelete:", toDelete);
}


function check() {
  try {
    
    let imagesExist = false;
    for (let i in photos) {
      if (photos[i].p != "") {
        imagesExist = true;
        break;
      }
    }
    
    if (imagesExist == false) throw "At least one image needs to be uploaded.";
    
  } catch (e) {
    console.log("error:", e);
  }
}


function done() {
  // console.log("done");
  photosAdd = false;
  if (photos[curPhotoId].p == "" && tempPhoto != "") {
    // console.log("new photo");
    // we have a new photo
    photos[curPhotoId].c = "new";
    photos[curPhotoId].i = Generate.id();
    photos[curPhotoId].p = tempPhoto;
    photos[curPhotoId].m = tempPhotoMedium;
    photos[curPhotoId].t = tempPhotoSmall;
  } else if (photos[curPhotoId].p != "") {
    // console.log("overwriting photo");
    // first, delete the old photo
    toDelete.push(photos[curPhotoId].i);
    toDelete.push(photos[curPhotoId].i + "_m");
    toDelete.push(photos[curPhotoId].i + "_t");
    // console.log("toDelete:", toDelete);
    // add the new
    photos[curPhotoId].c = "new";
    photos[curPhotoId].i = Generate.id();
    photos[curPhotoId].p = tempPhoto;
    photos[curPhotoId].m = tempPhotoMedium;
    photos[curPhotoId].t = tempPhotoSmall;
  }
}


export const doneAdding = async () => {
  if (photosAdd == true) {
    done();
  }
}


export const save = async () => {

  if (photosAdd == true) {
    done();
  }

  // console.log("photos:", photos);
  
  let photosToSave = false;
  for (let i in photos) {
    if (photos[i].p != "") {
      photosToSave = true;
    }
  }
  
  if (photosToSave == true) {
    
    auth.message("Saving Photos");
    
    // console.log("photos:", JSON.parse( JSON.stringify(photos) ) );
    // console.log("toDelete:", JSON.parse( JSON.stringify(toDelete) ) );
    
    // we have photos to save
    
    // build photoIds array and check that there are any photos to save
    let photoIds = [];
    let finalPhotoCommands = [];
    for (let i in photos) {
      
      // if not a no op, then save it to finalPhotoCommands
      if (photos[i].c == "new") {
        finalPhotoCommands.push(photos[i]);
      }
      
      if (photos[i].p != "") {
        photoIds.push(photos[i].i);
      }
      
    }
    
    if (finalPhotoCommands.length > 0 || toDelete.length > 0) {
      
      // create some empty space
      // console.log("photoIds.length:", photoIds.length);
      while (photoIds.length < 6) {
        photoIds.push("");
      }
      
      console.log("photoIds:", photoIds);
      console.log("finalPhotoCommands:", finalPhotoCommands);
      console.log("toDelete:", toDelete);
      
      // save photos
      let res = await auth.post("saveProfilePhotos", {photos: finalPhotoCommands, toDelete: toDelete});

      // save photoIds
      me.photoIds = photoIds;
      await profile.updateMe( { updateShare: true } );
      
    } else {
      console.log("nothing to save...");
    }
    
  } else {
    console.log("no photos - must have at least one", );
  }
  
}




</script>